import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
// import NavLink from '../components/LinkHack'
import shortid from 'shortid'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'

@inject('notifications')
@observer
class ProfileMenu extends Component {
  render () {
    const {notifications} = this.props

    const items = {
      'Dashboard': '/profile',
      'Benachrichtigungen': '/notifications',
      'Meine Erlebnisse': '/my-experiences',
      'Meine Buchungen': '/my-bookings',
      'Wunschliste': '/my-wishlist',
      'Einstellungen': '/settings'
    }

    return (
      <nav className='b-profile-menu'>
        <div className='b-profile-menu-inner'>
          {Object.keys(items).map((key, index) =>
            <NavLink key={shortid.generate()} to={items[key]}
                     className='b-profile-menu-item'>
              {key}
              {key === 'Benachrichtigungen' && notifications.has_unread_notification &&
              <div className='b-notification-dot b-notification-dot_right' />
              }
            </NavLink>
          )}
        </div>
      </nav>
    )
  }
}

ProfileMenu.propTypes = {
  notifications: MobxPropTypes.observableObject
}

export default ProfileMenu



// WEBPACK FOOTER //
// ./src/components/ProfileMenu.js